import './styles.scss'

import CartItem from '../CartItem'

const emptyListData = []

function CartItemList(props) {
  const {
    isLoading = false,
    listData = emptyListData,
    currencyUnit = '',
  } = props

  const renderList = () =>
    isLoading
      ? (
        <CartItem
          img={{ alt: '' }}
          isLoading={isLoading}
          materialNumber=""
          name=""
        />
      )
      : (
        listData.map((item) => {
          const {
            imgUrl,
            name,
            materialNumber,
            price,
            quantity,
            total,
            productReference,
          } = item
          return (
            <CartItem
              key={materialNumber}
              currencyUnit={currencyUnit}
              img={{ src: imgUrl, alt: name }}
              materialNumber={materialNumber}
              name={name}
              price={price}
              productReference={productReference}
              quantity={quantity}
              total={total}
            />
          )
        })
      )

  return (
    <div className="order-overview__middle-section__cart-item-list__wrapper fw-container">
      {renderList()}
    </div>
  )
}

export default CartItemList
